<script setup lang="ts">
export interface BadgeProps {
  text?: string | number;
  color?: string;
}

const props = withDefaults(defineProps<BadgeProps>(), {
  color: "var(--base-error-color)",
});
</script>

<template>
  <div class="badge relative">
    <div
      v-if="props.text"
      class="absolute w-4 h-4 left-4 -top-2 rounded-full text-center text-xs ring-2 ring-[var(--base-tab-background-color)] text-white"
      :style="{ background: props.color }"
    >
      {{ props.text }}
    </div>

    <slot />
  </div>
</template>
